<div class="entity-summary-container">
  <div class="summary">
    <div class="header">
      <img src="../../../../../../../assets/images/geo-car.svg" alt="car" class="h-15">
      <span class="ps-1">{{ MESSAGES?.DISTANCE }}</span>
    </div>
    <span class="value">{{ (summary?.distance || summary?.distance === 0) ? (summary?.distance ? ((summary?.distance).toFixed(2)+ 'Km') : '0 Km')  : '---' }}</span>
  </div>
  <div class="summary" *ngIf="trlConfig?.tenant !== 'VOT'">
    <div class="header">
      <img src="../../../../../../../assets/images/time-icon.svg" alt="time" class="h-15">
      <span class="ps-1">{{ MESSAGES?.TIME_TAKEN }}</span>
    </div>
    <span class="value">{{ (summary?.timeTaken || summary?.timeTaken === 0) ? (summary?.timeTaken ? (summary?.timeTaken | duration) : '0 min')  : '---' }}</span>
  </div>
</div>